import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import type { TooltipProps } from "@mui/material";
import { Tooltip } from "@mui/material";
import { ComponentProps, ReactElement, ReactNode } from "react";
import { faInfoCircle } from "web-fortawesome/npm/pro-light";

interface IInfoIconProps extends Omit<ComponentProps<typeof FontAwesomeIcon>, "icon"> {
	tooltip?: ReactNode;
	tooltipPlacement?: TooltipProps["placement"];
}

/**
 * An Icon providing additional information to the user when hovered.
 * @param tooltip - the tooltip
 * @param tooltipPlacement - the placement
 */
export function InfoIcon({ tooltip, tooltipPlacement, ...rest }: IInfoIconProps): ReactElement {
	return (
		<Tooltip title={tooltip ?? ""} placement={tooltipPlacement}>
			<span>
				<FontAwesomeIcon icon={faInfoCircle} {...rest} />
			</span>
		</Tooltip>
	);
}
